import {
  CreateBookingPassParam,
  FilterBookingPassesParam,
  ValidateBookingPassInBuildingParam,
} from '@resident-select/domain/booking-pass';
import { createEntityCommand } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';
import { SciGuaduaTransaction } from '@scifamek/guadua';

export const CreateBookingPassCommand = createEntityCommand<CreateBookingPassParam>(
  'CreateBookingPassCommand',
);

export const FilterBookingPassesCommand = createAction(
  'FilterBookingPassesCommand',
  props<SciGuaduaTransaction<FilterBookingPassesParam>>(),
);

export const ValidateBookingPassInBuildingCommand = createAction(
  'ValidateBookingPassInBuildingCommand',
  props<SciGuaduaTransaction<ValidateBookingPassInBuildingParam>>(),
);
